import ConfettiFull from './components/ConfettiFull';
import isConfettiOptionDirty from './utils/isConfettiOptionDirty';
import saveConfettiOption from './orchestration/saveConfettiOption';
import discardConfettiOption from './data/mutators/discardConfettiOption';
import * as React from 'react';
var ConfettiOption = {
    key: 'confetti',
    titleStringKey: 'optionTitle_confetti',
    searchTermsStringKey: 'optionTitle_confetti',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ConfettiFull, null); },
        isDirty: isConfettiOptionDirty,
        onSave: saveConfettiOption,
        onDiscard: discardConfettiOption,
    },
};
export default ConfettiOption;
//# sourceMappingURL=ConfettiOption.js.map